import { render, staticRenderFns } from "./index.vue?vue&type=template&id=174bd46d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProductMain: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/plp/ProductMain.vue').default,SearchLoadingIndicator: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/SearchLoadingIndicator.vue').default})
